







import { Component } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";

const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {}
})
export default class FactorContributionVisibilitySwitch extends Vue {


    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    set contributingVisibility(visible: boolean) {
        workspaceOptionsModule.changeContributingFactorVisibility(visible);
    }

}
